module.exports = __webpack_public_path__ + "static/media/received_2403125593244918.afa14cd7.jpeg";